/**
 * O selo do estado do bot num grupo — pronto, para a linha fechada da aba
 * Grupos não precisar remontar a regra.
 *
 * ⚠️ Arquivo só com o componente porque a regra `react-refresh` cobra: arquivo
 * que exporta componente E constante perde o hot-reload. As PALAVRAS do selo
 * ("bot dentro", "bot fora", "bot nunca conferido") moram no
 * `FiltroDeGrupos.tsx`, com o predicado — elas precisam ser as mesmas nas duas
 * telas que listam grupos, e o tri-estado só ensina se for dito igual em todo
 * lugar.
 */
import { Badge } from '@/components/ui';

import { SELO_DO_BOT, type EstadoDoBot } from './FiltroDeGrupos';

export function SeloDoBot({ bot, testId }: { bot: EstadoDoBot; testId?: string }) {
  const selo = SELO_DO_BOT[bot];
  return (
    <Badge variant={selo.variant} size="sm" data-testid={testId}>
      {selo.texto}
    </Badge>
  );
}
